import {customClientErrorHandler} from "~/services-optimized/customErrorService";
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";

import {toastErrors, toastSuccess} from "~/services-optimized/toastService";

type RequestOptions = {
    params?: Object|null;
    method?: 'get' | 'post' | 'put' | 'patch' | 'delete';
    query?: Object|null;
    headers?: Object|null;
    showNotifications?: Boolean;
    showLoadingIndicator?: Boolean;
    severity?: String|null;
    debug?: Boolean;
    timeout?: Number; // New timeout option
};


export const ajax = async (
    url: String,
    options: RequestOptions|null = null
) => {

    let config;
    let appDebug;

    if(import.meta.client)
    {
        config = useNuxtApp().$config;
        appDebug = useNuxtApp().$config.public.appDebug;
    }


    if(!options){
        options = {
            method: 'get', // Default value for method
            params: null,
            query: null,
            headers: null,
            showNotifications: true,
            showLoadingIndicator: true,
            severity: null,
            debug: false,
            timeout: 30000
        }
    }

    if(import.meta.client && options?.show_loading_indicator)
    {
        useLoadingIndicator().start()
    }


    if(appDebug){
        console.log('Ajax Request:', {
            url: url,
            options: options
        });
    }

    let req = {
        method: options.method
    };

    if (options.method === "get") {
        let queryString = '';
        if(options.query)
        {
            queryString = '?' +stringifyQueryString(options.query)
        }
        url = url +  queryString;
    } else {
        req.body = options.params
    }

    if (!options.headers) {
        req.headers = {
            accept: 'application/json'
        }
    }


    try {
        let data = await $fetch(url, req);

        if(appDebug){
            console.log('Ajax Response:', data);
        }

        if(import.meta.client && options?.show_loading_indicator) {
            useLoadingIndicator().finish();
        }

        if (import.meta.client && options?.show_notifications) {
            await processResponse(response);
        }


        return data;

    } catch (error) {

        if(import.meta.client){
            let errorData = {
                url: url,
                options: options,
                statusCode: error?.statusCode,
                requestUrl: error?.request,
                message: error?.message,
            }

            customClientErrorHandler(
                error,
                options.severity,
                'Ajax Response Error',
                errorData
            );
        }

        throw error;
    }
}



export const processResponse = async (response) => {
    if (response.errors || response.messages) {
        for (const toast_id of this.toast_ids) {
            await toast.remove(toast_id);
        }
    }

    if (response.errors && typeof response.errors[0] === "string") {
        await toastErrors(response.errors);
    }

    if (response.messages && typeof response.messages[0] === "string") {
        await toastSuccess(response.messages);
    }
}
